import { render, staticRenderFns } from "./DoorsIcons.vue?vue&type=template&id=2a719f6c&scoped=true&"
import script from "./DoorsIcons.vue?vue&type=script&lang=js&"
export * from "./DoorsIcons.vue?vue&type=script&lang=js&"
import style0 from "./DoorsIcons.vue?vue&type=style&index=0&id=2a719f6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a719f6c",
  null
  
)

export default component.exports